export const PAGE_GATE_LOADING = { type: 'loading' };
export const PAGE_GATE_AUTHORIZED = { type: 'authorized' };
//# sourceMappingURL=page-gate.js.map